
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-6552b748\",\"scoped\":true,\"hasInlineConfig\":false}!./ChatPanel.css")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChatPanel.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-6552b748\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChatPanel.vue"),
  /* scopeId */
  "data-v-6552b748",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/nudge-console/create-campaign/chat-panel/ChatPanel.vue
// module id = Y8Em
// module chunks = 1